import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDuplexStrainer = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 50,
	height: 40,
	viewBox: "0 0 50.0 40.0",
	...props,
	children: [
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 25,
			cy: 30,
			rx: 10,
			ry: 10,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 25,
			cy: 10,
			rx: 10,
			ry: 10,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M 0.0 20.0 L 50.0 20.0 M 50.0 10.0 L 50.0 30.0 M 0.0 10.0 L 0.0 30.0",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		})
	]
});
export default SvgDuplexStrainer;
